import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBV2dum79Q46OEhVLFCgYheMx81DfxuY1w",
  authDomain: "contalearn.firebaseapp.com",
  projectId: "contalearn",
  storageBucket: "contalearn.firebasestorage.app",
  messagingSenderId: "966545693931",
  appId: "1:966545693931:web:4cecb265d3286f943ff2ae"
};

const app = initializeApp(firebaseConfig);

// getMessaging() must never run at module scope: its factory touches
// navigator.serviceWorker synchronously and throws where that API is missing
// (iOS in-app browsers such as Instagram/LinkedIn/Facebook are WKWebViews with
// no service workers). That throw happened while the main bundle was still
// evaluating, before React mounted, so those users got a blank page.
// Resolve messaging lazily, and only where firebase says push is supported.
let messagingPromise = null;

export const getMessagingIfSupported = () => {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
};

export const VAPID_KEY = "BEgMsMsBpKJ2uRe2j6k6reNvcgerombVl5TFvUCFuwXU_ZYt2Y1HdhZrcwlBdo72J1u2TJ28ROReLLzbAm4o-J8";
